import React from 'react';
import AttachmentsPanel from './AttachmentsPanel';

function Deliverables({ projectId, users, currentUser, tasks }) {
  const tasksById = {};
  (tasks || []).forEach((t) => { tasksById[t.id] = t; });

  return (
    <div className="card">
      <h2>Livrables du projet</h2>
      <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 16, marginTop: -8 }}>
        Tous les documents du projet : livrables déposés ici et documents uploadés depuis les tâches apparaissent automatiquement.
      </p>
      <AttachmentsPanel
        projectId={projectId}
        users={users}
        currentUser={currentUser}
        tasksById={tasksById}
        emptyLabel="Aucun livrable déposé pour ce projet."
      />
    </div>
  );
}

export default Deliverables;
